import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const ADD_SCHOOL_TEACHER = gql`
  mutation AddSchoolTeacher($teacherEmail: String!) {
    addSchoolTeacher(email: $teacherEmail) {
      type,
      message
    }
  }
`;
